/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2022-01-17 08:00:00
 *
 *******************************************************/
//@flow

import React, { Component } from 'react';
import { connect } from 'react-redux';

import * as dashboardAction from 'actions/dashboard-actions';
import * as optionEmailAction from 'actions/dashboard/option-email-action';

import { Card, Layout, Button, TextContainer, Heading, FormLayout } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { Field, reduxForm } from 'redux-form';
import { isEmail, isExceedLength } from 'src/helpers/form-validation-helper';
import { RenderTextField } from 'src/components/views/common/forms/render-textfield';

import withBlockCanDismiss from './blockCanDismiss';
import optionEmail from 'src/assets/images/dashboard/optionEmail.png';
import Congrat from 'src/assets/images/dashboard/congrat.png';

type Props = {
  renderPopover: () => void
};

type ComposedProps = Props & WithI18nProps;

const isEmailValue = isEmail();
const isExceedLengthValue = isExceedLength(50);

class OptionInEmail extends Component<ComposedProps> {
  render() {
    const { renderPopover, i18n, loading, handleSubmit, pristine } = this.props;

    return (
      <Card>
        <Card.Header
          title={
            <div className="BC-OnboardingChecklist">
              <div className="BC_Card-Header">
                <Heading>
                  {i18n.translate('AdminHTML.Common.FieldLabel.signupEmail')}{' '}
                  <img className="icon" src={Congrat} alt="" />
                </Heading>
              </div>
            </div>
          }>
          <div className="BC-Block-Dismiss--Right-Menu">{renderPopover()}</div>
        </Card.Header>
        <Card.Section>
          <div className="BC-Email__Dashboard">
            <Layout>
              <Layout.Section>
                <TextContainer>
                  <FormLayout>
                    <Field
                      name="optEmail"
                      label={i18n.translate('AdminHTML.Common.FieldLabel.email')}
                      component={RenderTextField}
                      placeholder={i18n.translate('AdminHTML.Common.Placeholder.email')}
                      validate={[isEmailValue, isExceedLengthValue]}
                    />
                  </FormLayout>
                  <Button
                    primary
                    loading={loading && !pristine}
                    onClick={handleSubmit(this.handleSubmit.bind(this))}>
                    {i18n.translate('AdminHTML.Common.Action.submit')}
                  </Button>
                </TextContainer>
              </Layout.Section>
              <Layout.Section secondary>
                <div className="BC-Illustration-Image__Dashboard">
                  <img
                    src={optionEmail}
                    alt={i18n.translate('AdminHTML.Dashboard.Common.optionEmail')}
                  />
                </div>
              </Layout.Section>
            </Layout>
          </div>
        </Card.Section>
      </Card>
    );
  }

  // Handle default form submit
  handleDefaultSubmit(e) {
    e.preventDefault();
  }

  //Handle submit
  handleSubmit = async data => {
    const { addOptionEmail, dismissDashboardBlock } = this.props;
    if (data.optEmail) {
      const result = await addOptionEmail(data);
      if (result.type === 'ADD_OPTION_EMAIL_SUCCESS') {
        dismissDashboardBlock('optionInEmail');
      }
    }
  };
}

const mapStateToProps = (state, props) => ({
  loading: state.optionEmail.loading,
  success: state.optionEmail.success,
  error: state.optionEmail.error
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  addOptionEmail: (body: Object) => dispatch(optionEmailAction.addOptionEmail(body, ownProps.i18n)),
  dismissDashboardBlock: (blockName: string) =>
    dispatch(dashboardAction.processDismissBlock(blockName, ownProps.i18n))
});

const OptionEmailForm = reduxForm({
  form: 'OptionInEmail', // a unique identifier for this form
  enableReinitialize: true
})(OptionInEmail);

export default withBlockCanDismiss(
  withI18n()(connect(mapStateToProps, mapDispatchToProps)(OptionEmailForm))
);
